export default function SectionBox({ children, className = "" }) {
  return (
    <div
      className={`bg-black bg-opacity-30 backdrop-blur-md rounded-lg p-6 sm:p-8 md:p-10 max-w-4xl w-full text-white text-center border border-red-500/40 shadow-[0_0_20px_rgba(248,113,113,0.35)] ${className}`.trim()}
    >
      {children}
    </div>
  );
}
  
